import React from 'react'

/**
 * @return {null}
 */
export default function IssuedStatusCell({value}) {
  return value === true ? <span>Issued</span> : null
}
